import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';

import "react-sliding-pane/dist/react-sliding-pane.css";

const MapViewer = forwardRef(({ openPanel }, ref) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const scrollContainerRef = useRef(null);
  const imageRef = useRef(null);

  const pinData = {
    "A": { "title": "봉안묘", "subtitle": "거북(龜) 묘역" },
    "B": { "title": "봉안담", "subtitle": "천의 바람" },
    "C": { "title": "봉안담", "subtitle": "거북 봉안담" },
    "D": { "title": "평장묘", "subtitle": "무우원(無憂園)" },
    "E": { "title": "봉안담", "subtitle": "거북 봉안담" },
    "F": { "title": "평장묘", "subtitle": "상수대(桑樹臺)" },
    "G": { "title": "봉안묘", "subtitle": "문형D(文衡D)" },
    "H": { "title": "봉안묘", "subtitle": "자심당 (慈心堂) " },
    "I": { "title": "봉안묘", "subtitle": "회향헌(廻向軒) 2구역" },
    "J": { "title": "봉안묘", "subtitle": "사슴(鹿) 묘역" },
    "K": { "title": "평장묘", "subtitle": "석복원(錫福園)" },
    "L": { "title": "봉안묘", "subtitle": "윤솔헌" },
    "M": { "title": "봉안묘", "subtitle": "탐랑헌" },
    "N": { "title": "봉안묘", "subtitle": "불로초(不老草) 묘역" },
    "O": { "title": "봉안담", "subtitle": "소나무 봉안담" },
    "P": { "title": "봉안묘", "subtitle": "소나무(松) 묘역" },
    "Q": { "title": "평장묘", "subtitle": "소나무 공원" },
    "R": { "title": "봉안묘", "subtitle": "구름(雲) 묘역" },
    "S": { "title": "봉안묘", "subtitle": "학(鶴) 묘역" },
    "T": { "title": "봉안담", "subtitle": "학 봉안담" },
    "U": { "title": "봉안담", "subtitle": "학 봉안담" },
    "V": { "title": "평장묘", "subtitle": "자미원(紫薇園)" },
    "W": { "title": "봉안묘", "subtitle": "해(太陽) 묘역" },
    "X": { "title": "봉안묘", "subtitle": "바위(巖) 묘역" },
    "Y": { "title": "봉안담", "subtitle": "바위 봉안담" },
    "Z": { "title": "평장묘", "subtitle": "안정원(安靜園)" },
    "Z1": { "title": "모모헌", "subtitle": "" },
  };

  const positions = [
    { x: 13.7, y: 80, item: pinData.A },
    { x: 18.5, y: 68.47, item: pinData.B },
    { x: 19.18, y: 63, item: pinData.C },
    { x: 21.5, y: 55.2, item: pinData.D },
    { x: 21.5, y: 62.6, item: pinData.A },
    { x: 25, y: 60, item: pinData.E },
    { x: 26, y: 67, item: pinData.F },
    { x: 26.3, y: 81, item: pinData.G },
    { x: 28, y: 88.5, item: pinData.H },
    { x: 30.3, y: 87.5, item: pinData.I },
    { x: 36.6, y: 77, item: pinData.J },
    { x: 36.9, y: 69.7, item: pinData.K },
    { x: 34.3, y: 36.5, item: pinData.M },
    { x: 32, y: 44.4, item: pinData.N },
    { x: 37, y: 41, item: pinData.N },
    { x: 36.2, y: 52.8, item: pinData.O },
    { x: 44, y: 43.2, item: pinData.P },
    { x: 49.5, y: 41.2, item: pinData.Q },
    { x: 48, y: 50.2, item: pinData.R },
    { x: 55.3, y: 32.8, item: pinData.S },
    { x: 54.5, y: 45.5, item: pinData.T },
    { x: 59.5, y: 40, item: pinData.U },
    { x: 62, y: 37, item: pinData.V },
    { x: 61, y: 46, item: pinData.W },
    { x: 58.3, y: 23, item: pinData.X },
    { x: 44.3, y: 23, item: pinData.X },
    { x: 47.1, y: 27, item: pinData.X },
    { x: 53.3, y: 22, item: pinData.Y },
    { x: 48.1, y: 22.5, item: pinData.Z },
    { x: 35.1, y: 60.5, item: pinData.Z1 },
  ];

  // 이미지 크기 업데이트 함수
  const updateImageDimensions = () => {
    if (imageRef.current) {
      const img = imageRef.current;
      setImageDimensions({
        width: img.offsetWidth,
        height: img.offsetHeight
      });
    }
  };

  // 터치 이벤트로 rubber band effect 방지
  const handleTouchMove = (e) => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      if (
        (scrollLeft <= 0 && e.touches[0].clientX > e.touches[0].clientX) ||
        (scrollLeft >= scrollWidth - clientWidth && e.touches[0].clientX < e.touches[0].clientX)
      ) {
        e.preventDefault();
      }
    }
  };

  useEffect(() => {
    const carouselContainers = document.querySelectorAll('.carousel-container');
    if (carouselContainers.length > 0) {
      const originalOverflows = Array.from(carouselContainers).map(container => container.style.overflow);
      carouselContainers.forEach(container => {
        container.style.overflow = 'auto';
      });
      return () => {
        carouselContainers.forEach((container, index) => {
          container.style.overflow = originalOverflows[index] || 'hidden';
        });
      };
    }
  }, []);

  // 브라우저 크기 변경 감지 및 이미지 크기 업데이트
  useEffect(() => {
    const handleResize = () => {
      updateImageDimensions();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleImageLoad = () => {
    setImageLoaded(true);
    updateImageDimensions();
  };

  // 배경색을 #F3F3F4로 지정
  const mapViewerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    touchAction: 'pan-x',
    background: '#F3F3F4',
  };

  const scrollContainerStyle = {
    width: '100%',
    height: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
    touchAction: 'pan-x',
    background: '#F3F3F4', // 스크롤 컨테이너도 배경색 적용
  };

  const contentContainerStyle = {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    width: 'max-content',
    minWidth: '100%',
    background: '#F3F3F4', // 컨텐츠 컨테이너도 배경색 적용    
  };

  const mapImageStyle = {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
    objectPosition: 'left top',
    display: 'block',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    background: '#F3F3F4', // 이미지 배경도 동일하게
  };

  const pinContainerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: `${imageDimensions.width}px`,
    height: `${imageDimensions.height}px`,
    pointerEvents: 'none',
  };

  const pinStyle = {
    position: 'absolute',
    width: '50px',
    height: '50px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    zIndex: 100,
    userSelect: 'none',
    WebkitUserSelect: 'none',
    pointerEvents: 'auto',
  };

  return (
    <div style={mapViewerStyle}>
      <div
        className="map-scroll-container"
        style={scrollContainerStyle}
        ref={scrollContainerRef}
        onTouchMove={handleTouchMove}
      >
        <div style={contentContainerStyle}>
                   
          {/* 배경 지도 이미지 */}
          <img
            ref={imageRef}
            src="sian-map.png"
            alt="시안 지도"
            style={mapImageStyle}
            onLoad={handleImageLoad}
            draggable={false}
          />
          <div id="pin-container" style={pinContainerStyle}>
           {/* 핀들 - 이미지가 로드된 후에만 표시 */}
            {imageLoaded && positions.map((position, index) => (
              <img
                key={index}
                src="pin.png"
                alt={`핀 ${index}`}
                style={{
                  ...pinStyle,
                  left: `${position.x}%`,
                  top: `${position.y}%`,
                  transform: 'translate(-50%, -50%)',
                }}
                onClick={() => openPanel(position.item.title, position.item.subtitle)}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translate(-50%, -50%) scale(1.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translate(-50%, -50%) scale(1)';
                }}
                draggable={false}
              />
            ))}
          </div>
          


        </div>
      </div>
    </div>
  );
});

export default MapViewer;